import { customersApi } from './generated/customersApi';
import { dashboardApi } from './generated/dashboardApi';
import { orderChatApi } from './generated/orderChatApi';
import { ordersApi } from './generated/ordersApi';

/**
 * Cache links that cross API tags.
 *
 * Codegen tags every endpoint with its own OpenAPI tag only. These overrides add the edges
 * between them, so a change on one screen refreshes what it affects on another. They live
 * outside src/api/generated so `npm run codegen` cannot overwrite them.
 *
 * Imported once for its side effect, from app/store.ts. `enhanceEndpoints` mutates the shared
 * api, so the hooks exported by the generated files pick these up.
 */
ordersApi.enhanceEndpoints({
  addTagTypes: ['Customers', 'Order chat'],
  endpoints: {
    // A new order changes the customer's order count.
    createOrder: { invalidatesTags: ['Orders', 'Customers'] },
    // A status change can post to the chat.
    updateOrder: { invalidatesTags: ['Orders', 'Order chat'] },
  },
});

orderChatApi.enhanceEndpoints({
  addTagTypes: ['Orders'],
  endpoints: {
    // The order list shows each chat's last message and unread count.
    sendOrderMessage: { invalidatesTags: ['Order chat', 'Orders'] },
  },
});

customersApi.enhanceEndpoints({
  addTagTypes: ['Orders'],
  endpoints: {
    // Orders show the customer's name and contact details.
    updateCustomer: { invalidatesTags: ['Customers', 'Orders'] },
  },
});

dashboardApi.enhanceEndpoints({
  addTagTypes: ['Orders', 'Customers'],
  endpoints: {
    // Every figure is counted from orders and customers, so a write that refreshes either list
    // refreshes the dashboard too.
    getDashboard: { providesTags: ['Dashboard', 'Orders', 'Customers'] },
  },
});
